<script setup lang="ts">
import WidgetRecordAction from '@components/widget/WidgetRecordAction.vue'

const { records, isSelected } = defineProps<{
  records: any[],
  isSelected: Function,
}>()

const emit = defineEmits(['select', 'unselect'])
</script>

<template>
  <VTable v-if="records?.length">
    <thead>
      <tr>
        <th>
          Пол
        </th>
        <th>
          Тип
        </th>
        <th>
          Размер
        </th>
        <th class="text-center mw-100">
          Действие
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="record in records"
        :key="record.Uuid"
      >
        <td>{{ record.Sex }}</td>
        <td>{{ record.Type }}</td>
        <td>
          {{ record.Size }}
          <VSpacer />
        </td>
        <td class="text-center">
          <WidgetRecordAction
            :selected="isSelected(record.Uuid)"
            @set="emit('select', record)"
            @delete="emit('unselect', record)"
          />
        </td>
      </tr>
    </tbody>
  </VTable>

  <VListItem v-else>
    Нет данных.
  </VListItem>
</template>